import { render, staticRenderFns } from "./popularize.vue?vue&type=template&id=e1588c1a&scoped=true&"
import script from "./popularize.vue?vue&type=script&lang=js&"
export * from "./popularize.vue?vue&type=script&lang=js&"
import style0 from "./popularize.vue?vue&type=style&index=0&id=e1588c1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1588c1a",
  null
  
)

export default component.exports